import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function FormularInscrierePage() {
  return (
    <>
      <Navbar variant="light" onlyLogo />
      
      {/* Contact Form Section */}
      <section className="form-section" id="formular">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Rezervă-ți locul</h2>
            <p className="section-subtitle">Completează formularul și intră în lista prioritară</p>
          </div>
          
          <div className="form-wrapper">
            <iframe
              src="https://link.kerrsid.com/widget/form/LmO9YXR3MHQF2ZO9U9pg"
              style={{ width: '100%', minHeight: '700px', height: '100%', border: 'none', borderRadius: '16px' }}
              id="inline-LmO9YXR3MHQF2ZO9U9pg" 
              data-layout="{'id':'INLINE'}"
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="neverDeactivate"
              data-deactivation-value=""
              data-form-name="Formular Contact - Brain Event"
              data-height="442"
              data-layout-iframe-id="inline-LmO9YXR3MHQF2ZO9U9pg"
              data-form-id="LmO9YXR3MHQF2ZO9U9pg"
              title="Formular Contact - Brain Event">
            </iframe>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default FormularInscrierePage;

